mtl.alloy.factory['submit-on-click'] = (function($) {
    'use strict';

    return function(element, options) {

        $('.submit', element).on('click', function(){
            $(element).closest('form').submit();
        });

        $('.submit', element).css('cursor', 'pointer');

    };

}(jQuery));
